export const STRINGS = {
  upload: 'Ladda upp bild',
  choose: 'Välj bild',
  dropHint: 'Dra hit en bild eller tryck för att välja',
  rights: 'Jag bekräftar att jag har rätt att använda bilden – att jag själv äger den eller har tillstånd från den som gör det.',
  tooLarge: 'Bilden är för stor (max 8 MB)',
  badFormat: 'Bilder i {format} går inte att använda här – spara om bilden som JPEG eller PNG och försök igen',
  brokenImage: 'Bilden kunde inte öppnas – prova en annan bild',
  portrait: 'Stående',
  landscape: 'Liggande',
  addText: 'Lägg till text',
  addImage: 'Lägg till bild',
  tooManyImages: 'Max 10 bilder',
  typeText: 'Skriv din text',
  font: 'Typsnitt',
  color: 'Färg',
  shadow: 'Skugga',
  size: 'Storlek',
  width: 'Bredd',
  height: 'Höjd',
  sheetIs: 'Arket är',
  remove: 'Ta bort',
  done: 'Klar',
  settings: 'Inställningar',
  ruler: 'Linjal',
  rotate: 'Rotera',
  zoom: 'Zooma',
  lowRes: 'Bilden är lågupplöst och kan bli suddig i tryck',
  notCovered: 'Bilden täcker inte hela ytan – det som är vitt här blir vitt på tårtan',
  fakeTransparency: 'Bilden har ett rutmönster som bakgrund (inte äkta genomskinlighet) – rutorna kommer med i trycket',
  save: 'Spara',
  cancel: 'Avbryt',
  saving: 'Sparar…',
  error: 'Något gick fel, försök igen',
  tooMany: 'För många försök, vänta en stund och försök igen',
  edit: 'Redigera',
  restart: 'Börja om',
  saved: 'Din bild är sparad',
  loading: 'Laddar bild…',
  buyBlocked: 'Du måste ladda upp en bild först',
};
export type Strings = typeof STRINGS;
